import React from "react";
import Utils from "../../utils/utils";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import getLezioni from "../../services/getLezioni";
import getStudenti from "../../services/getStudenti";
import getCorsi from "../../services/getCorsi";
import getPresenzeCorso from "../../services/getPresenzeCorso";
import AssenzaWidget from "./AssenzeWidget";
import getPresenzeStudente from "../../services/getPresenzeStudente";
import getLezioniSvolte from "../../services/getLezioniSvolte";
import { pdf } from "@react-pdf/renderer";
import getPresenzeCorsoStudente from "../../services/getPresenzeCorsoStudente";
import { getAssenzeCrossCorso } from "../../services/addPresenzaCrossCorso";

export default class GestioneAssenze extends React.Component {
  constructor(props) {
    super(props);

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.section = this.props.section;
    if (this.section == undefined) {
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined) {
      this.pageName = this.section;
    }

    this.userslist = [];

    this.state = {
      testo: "",
      menuBackground: "#ffffff",
      menuItemColor: "#000000",
      fontSize: 50,
      fontBold: false,
      logoPicture: "",
      logoMargin: 0,
      titleColor: "#000000",
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
    };

    this.grid = 2;

    this.pageTitle = "Gestione Assenze";

    this.state = {
      isLoading: true,
      corsi: [],
      lezioni: [],
      assenze: [],
    };
  }

  async componentDidMount() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentStudente = cookies.get("currentStudente", { path: "/" });
    this.studenti = await getStudenti(username, token);
    this.corsi = await getCorsi(username, token);
    this.lezioni = await getLezioni(username, token);
    const parsed = require("querystring").parse(window.location.hash);

    let currStudente = this.studenti.find(
      (s) => s.id === parseInt(currentStudente, 10)
    );

    let corso = parsed["#/app/gestioneAssenze?corso"];
    let corsi = undefined;
    this.presenzeAll = await getPresenzeCorso(username, token, corso);

    this.presenzeAll = this.presenzeAll.filter(
      (p) => p.id_studente === currStudente.id
    );

    // ✅ NUOVO: Carica anche le assenze cross-corso (da corsi precedenti)
    console.log(
      "[GestioneAssenze] Caricamento assenze cross-corso per studente",
      currStudente.id
    );
    const assenzeCrossCorso = await getAssenzeCrossCorso(
      username,
      token,
      currStudente.id
    );

    if (
      assenzeCrossCorso &&
      assenzeCrossCorso.result === "ok" &&
      assenzeCrossCorso.assenze_cross_corso
    ) {
      console.log(
        "[GestioneAssenze] Trovate",
        assenzeCrossCorso.assenze_cross_corso.length,
        "assenze cross-corso"
      );

      // Crea una mappa delle presenze già esistenti per evitare duplicati
      const presenzeMap = new Map();
      this.presenzeAll.forEach((p) => {
        const key = `${p.id_lezione}_${p.id_sessione || "null"}`;
        presenzeMap.set(key, p);
      });

      // Aggiungi solo le assenze cross-corso che non sono già presenti
      assenzeCrossCorso.assenze_cross_corso.forEach((assenzaCross) => {
        const key = `${assenzaCross.id_lezione}_${assenzaCross.id_sessione ||
          "null"}`;
        if (!presenzeMap.has(key)) {
          // Converti l'assenza cross-corso nel formato presenza
          const presenzaCross = {
            id: null, // Le assenze cross-corso potrebbero non avere un ID presenza nel corso attuale
            id_studente: currStudente.id,
            id_lezione: assenzaCross.id_lezione,
            id_sessione: assenzaCross.id_sessione,
            presenza: "-1",
            giustificata: assenzaCross.giustificata || "0",
            data: assenzaCross.data,
            durata: assenzaCross.durata || 180,
            id_recupero: assenzaCross.id_recupero,
            cross_corso: true, // Flag per distinguere le assenze cross-corso
          };

          this.presenzeAll.push(presenzaCross);
          console.log(
            "[GestioneAssenze] Aggiunta assenza cross-corso:",
            presenzaCross
          );
        }
      });
    }

    if (corso !== undefined) {
      const corsiArray = Utils.parseCorsi(currStudente.corsi);
      if (corsiArray.includes(corso.toString())) {
        corsi = this.corsi.filter((c) => c.id === parseInt(corso, 10));
      }
    } else {
      const corsiArray = Utils.parseCorsi(currStudente.corsi).map((id) =>
        parseInt(id, 10),
      );
      corsi = this.corsi.filter((c) => corsiArray.includes(c.id));
    }

    this.oreTotali = 0.0;
    this.oreSvolte = 0.0;

    const lezioniMap = this.lezioni.reduce((acc, lezione) => {
      acc[lezione.id] = { data: lezione.data, durata: lezione.durata };
      return acc;
    }, {});

    this.presenzeAll.forEach((p) => {
      const lezione = lezioniMap[p.id_lezione];
      if (lezione) {
        p.data = lezione.data;
        p.durata = lezione.durata;
      }
    });

    this.assenze = this.presenzeAll.filter(
      (presenza) => presenza.presenza == "-1"
    );
    this.presenze = this.presenzeAll.filter((p) => p.presenza == "1");

    console.log(
      "[GestioneAssenze] Totale assenze (incluse cross-corso):",
      this.assenze.length
    );

    this.presenzeAll.forEach((p) => {
      if (p.presenza == "1") {
        if (p.ore !== "") {
          this.oreSvolte += parseInt(p.ore);
        } else {
          this.oreSvolte += parseFloat(p.durata) / 60;
        }
      }
      this.oreTotali += parseFloat(p.durata) / 60;
    });

    var counts = [];
    corsi.forEach((c) => {});

    this.setState({
      isLoading: false,
      studente: currStudente,
      corsi: corsi,
    });
  }

  render() {
    if (this.state.isLoading) return <div />;
    else
      return (
        <>
          <PageTitle
            title={
              this.pageTitle +
              ": " +
              this.state.studente.nome +
              " " +
              this.state.studente.cognome
            }
          />
          {this.state.corsi.map((corso, ind) => {
            let g = this.assenze.filter((a) => a.giustificata == "1");
            let ng = this.assenze.filter((a) => a.giustificata == "0");

            let totali = this.presenzeAll;
            let assenze = this.presenzeAll.filter((p) => p.presenza == "-1");
            let percent = 1.0 - parseFloat(this.oreSvolte / this.oreTotali);

            console.log(
              "ore svolte",
              this.oreSvolte,
              "ore totali",
              this.oreTotali
            );

            let finalPerc = (percent * 100).toFixed(2);

            let numbs =
              String(totali.length - assenze.length) +
              "/" +
              String(totali.length);

            return (
              <div
                key={Math.random()}
                style={{
                  backgroundColor: "#DDE9F1",
                  borderRadius: "10px",
                  paddingLeft: "30px",
                  paddingRight: "30px",
                  paddingBottom: "30px",
                  paddingTop: "15px",
                  marginBottom: "10px",
                }}
              >
                <h3 style={{ fontWeight: "bold" }}>
                  {corso.name}: {isNaN(finalPerc) ? "0.0" : finalPerc}% ({numbs}
                  ) ({g.length} G / {ng.length} NG)
                </h3>
                {this.assenze.length === 0 && (
                  <p style={{ color: "darkgrey" }}>Nessuna assenza</p>
                )}
                {this.assenze.map((assenza, i) => {
                  return (
                    <AssenzaWidget
                      key={Math.random()}
                      assenza={assenza}
                      onChange={(giustifica) => {
                        if (giustifica) {
                          this.assenze[i].giustificata = "1";
                          this.setState({});
                        } else {
                          this.assenze[i].giustificata = "0";
                          this.setState({});
                        }
                      }}
                    />
                  );
                })}
              </div>
            );
          })}
        </>
      );
  }
}
